import React from 'react'

function Footer() {
    return (
        <footer className="text-gray-600 body-font self-center">
            <div className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
                <a href="/" className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-10 h-10 text-white p-2 bg-blue-500 rounded-full" viewBox="0 0 24 24">
                        <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    <span className="blue-654C ml-3 text-xl">Centro de Desarrollo de Software</span>
                </a>
                {/* <p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">© 2022 CDSOFT </p>    */}
                <div className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">Developed By CDSOFT - © 2022 <br /> Powered By <a id="cdsoftlnk" className="text-orange-500" href="https://www.youtube.com/watch?v=vKFSi9QeVH8" target="_blank" rel="noopener noreferrer">UFG Cloud</a></div>             
            </div>
        </footer>
    )
}

export default Footer